<template>
  <div v-if="data" class="modal--addUser">
    <div class="modalCustom__header">
      <h5 class="">{{ data.header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <div class="row">
        <div class="w-full">
          <label for="company_name" class="control-label">{{ $t('name') }}</label>
          <fg-input
            type="text"
            id="company_name"
            :placeholder="$t('company_name')"
            v-model="name"
            addon-left-icon="ti ti-pencil"
            @input="name = $event"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="w-full">
          <label for="city" class="control-label">City</label>
          <fg-input
            type="text"
            id="city"
            placeholder="New York"
            v-model="city"
            addon-left-icon="ti ti-pencil"
            @input="city = $event"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="w-full">
          <label for="country_code" class="control-label">Country code</label>
          <fg-input
            type="text"
            id="country_code"
            placeholder="US"
            v-model="country_code"
            addon-left-icon="ti ti-pencil"
            @input="country_code = $event"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="w-full">
          <label for="description" class="control-label">{{ $t('description') }}</label>
          <fg-input
            type="text"
            id="description"
            :placeholder="$t('description')"
            v-model="description"
            addon-left-icon="ti ti-pencil"
            @input="description = $event"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="w-full">
          <label for="company_website" class="control-label">{{ $t('website') }}</label>
          <fg-input
            type="text"
            id="company_website"
            placeholder="https://company_name.com/"
            v-model="company_website"
            addon-left-icon="ti ti-world"
            @input="company_website = $event"
          >
          </fg-input>
        </div>
      </div>
    </div>

    <div class="modalCustom__footer">
      <!--            buttons                   -->
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div>
        <p-button type="success" round @click.native.prevent="createCompany">
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import CreateNewButton from '../buttons/CreateNewButton';
import SvgName from '../svg/SvgName';
import SmallInput from '../Inputs/SmallInput';
import SvgDescription from '../svg/SvgDescription';
import CancelButton from '../buttons/CancelButton';
import SaveButton from '../buttons/SaveButton';
import SvgWebsite from '../svg/SvgWebsite';
import axiosAuth from '../../axiosMain';
export default {
  name: 'CreateCompanyModal',
  components: { SvgWebsite, SaveButton, CancelButton, SvgDescription, SmallInput, SvgName, CreateNewButton },
  props: {
    data: {
      type: Object,
    },
  },
  data: function () {
    return {
      open: false,
      name: '',
      description: '',
      company_website: '',
      city: '',
      country_code: '',
    };
  },
  methods: {
    closeModal: function () {
      this.$emit('close');
    },
    createCompany: function () {
      axiosAuth
        .post(
          '/companies',
          {
            name: this.name,
            description: this.description,
            company_website: this.company_website,
            city: this.city,
            country_code: this.country_code,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.$emit('submit', response.data);
          this.closeModal();
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('The_company_was_created'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data,
          });
        });
    },
  },
};
</script>

<style scoped></style>
